<script lang="ts">
  import type { UserType } from '$src/types/user';
  import type { UrlType } from '$src/types/user';

  const { user, profileUrl }: { user: UserType; profileUrl: UrlType } =
    $props();
</script>

<div class="2xl:fluid-gap-[16] flex flex-col gap-4">
  <div class="text-14px leading-[180%]">
    <strong>{user.firstName} {user.lastName}</strong><br />
    E-mail: <strong>{user.email}</strong><br />
    Tel.: <strong>{user.phoneNumber}</strong>
  </div>

  <p class="text-12px">
    Kloppen deze gegevens niet meer? <a
      href={profileUrl}
      class="link-decoration-yellow underline underline-offset-[20%]"
      >Werk ze bij in je profiel</a
    >
  </p>
</div>
